exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-full-details-table {\n  padding-top: 8px;\n  padding-bottom: 20px;\n  width: 100%;\n  overflow-x: auto; }\n\n.service-column-key-padding {\n  padding-bottom: 4px; }\n\n.service-card-content {\n  width: 100%; }\n  .service-card-content .service-column-padding {\n    margin-left: 24px; }\n\n.service-basic-column-size {\n  width: 104px;\n  min-width: 104px; }\n\n.service-extip-column-size {\n  width: 124px; }\n\n.service-tags-column-size {\n  min-width: 150px; }\n", ""]);

// exports
